package pipeline

import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.graphics.Mesh
import com.github.chosamuel.kishibe.graphics.createMesh
import geometry.Eye

fun Application.createEyelidMesh(c: Eye): Mesh { //c for crescent
    val eyelidMesh = createMesh()
    val pts = c.getVertices()
    repeat(c.resolution){
        val i = (it.toDouble() / c.resolution.toDouble())*0.5
        eyelidMesh.addVertex(pts[0][it])
        eyelidMesh.addVertex(pts[1][it])
        eyelidMesh.addColor(Color(1.0,i,0.0))
        eyelidMesh.addColor(Color(1.0,i+0.5,0.0))
    }
    repeat(c.resolution*2){
        eyelidMesh.addIndex(it.toShort())
    }

    return eyelidMesh
}